import CloseIcon from '@mui/icons-material/Close';
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Button,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { login, setEnrollCookie } from 'src/helpers/auth';

import { useCssClasses } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

/**
 * @deprecated using LoginModal (@components/share/modal/loginModal/LoginModal.tsx) instead
 */
const LoginModal = ({ dialog, redirectUrl = '' }: any) => {
  const classes = useCssClasses();
  const theme = useTheme();
  const onClick = () => {
    setEnrollCookie(redirectUrl);
    login(redirectUrl);
  };

  return (
    <>
      <DialogTitle classes={{ root: classes.root }}>
        <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
          <IconButton onClick={dialog.close} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box display="flex" alignItems="center" flexDirection="column" rowGap="1">
          <FontAwesomeIcon
            style={{ fontSize: '50px' }}
            color={theme.palette.grey[500]}
            icon="fa-light fa-circle-exclamation"
          />
          <Typography color="primary.main" variant="h3" align="center" sx={{ mt: 2 }}>
            กรุณาเข้าสู่ระบบหรือสมัครสมาชิกเพื่อดำเนินการต่อ
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography
            sx={{ fontFamily: 'Lanna' }}
            variant="body2_deprecated"
            align="center"
            display="flex"
            flexDirection="row"
            justifyContent="center"
            className={classes.loginDescription}
          >
            <span>หากคุณยังไม่มีบัญชีผู้ใช้</span>
            <span>กรุณาสมัครบัญชีผู้ใช้และเข้าสู่ระบบ</span>
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={onClick} sx={{ mt: '6px', width: '120px' }} variant="contained" color="primary">
          เข้าสู่ระบบ
        </Button>
      </DialogActions>
    </>
  );
};

export default LoginModal;
